import Slider from 'rc-slider'
import Wave from './wave'
import Helper from '../helpers/helper'
import filesize from 'filesize'
import Tooltip from './tooltip'

const symbols = {
  'CZK': 'Kč',
  'EUR': '€',
  'USD': '$'
}

class Pricing extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      currency: (I18n.locale == 'cs' ? 'CZK' : 'EUR'),
      period: 'monthly',
      users: 1,
      plans: []
    };
  }

  componentDidMount() {
    this.fetchPlans()
  }

  fetchPlans() {
    $.ajax({
      url: this.props.plans_url,
      success: (data) => {
        this.setState({plans: data.plans})
      }
    })
  }

  handleDollarChange(e) {
    if (e.target.checked) {
      this.setState({currency: 'USD'})
    } else {
      this.setState({currency: 'EUR'})
    }
  }

  handlePeriodChange(e) {
    if (e.target.checked) {
      this.setState({period: 'monthly'})
    } else {
      this.setState({period: 'yearly'})
    }
  }

  handleSliderChange(count) {
    this.setState({users: count})
  }

  handleUsersInputChange(e) {
    if (e.target.value) this.setState({users: parseInt(e.target.value)})
  }

  render() {
    // let offset = I18n.locale == 'cs' ? 0 : 1
    let offset = 0
    let symbol = symbols[this.state.currency]
    let plans = this.state.plans.filter(i => i.price_czk != 0)
    let defaultPlan = this.state.plans.find(i => i.default == true)

    let supportEmail = 'support@caflou.com'
    let pricingItemsHintLink = 'https://www.caflou.com/what-do-the-price-list-items-mean'
    if (I18n.locale == 'cs') {
      pricingItemsHintLink = 'https://www.caflou.cz/co-ktere-polozky-ceniku-znamenaji'
      supportEmail = 'podpora@caflou.cz'
    }

    return (
      <div className="pricing">
        <div className="order-flow">

          {/*}<div className="step">
            <div className="number">
              {offset + 1}
            </div>
            <div className="title">
              {I18n.t('payment-period')}
            </div>
            <div className="selection">
              <div className="period-switcher">
                <div className="period flex">
                  <div className="savings-tag">Save up to 20%</div>
                  <div className="name">{I18n.t('yearly')}</div>
                </div>
                <div className="onoffswitch">
                  <input
                    type="checkbox"
                    name="monthly"
                    id="monthly"
                    className="onoffswitch-checkbox"
                    onChange={this.handlePeriodChange.bind(this)} />
                  <label className="onoffswitch-label" htmlFor="monthly">&nbsp;</label>
                </div>
                <div className="period">{I18n.t('monthly')}</div>
              </div>
            </div>
          </div>*/}

          <div className="step">
            <div className="number">
              {offset + 1}
            </div>
            <div className="title">
              {I18n.t('number-of-users')}
            </div>
            <div className="selection slider-wrapper">
              <div className="slider">
                <Slider
                  min={1}
                  max={50}
                  step={1}
                  onChange={this.handleSliderChange.bind(this)} />
              </div>
              <div className="input">
                <input type="number" min="1" value={this.state.users} onChange={this.handleUsersInputChange.bind(this)} />
              </div>
            </div>
          </div>

          <div className="step">
            <div className="number">
              {offset + 2}
            </div>
            <div className="title">
              {I18n.t('choose-plan')}
            </div>
            <div className="selection">

            </div>
          </div>

          <div className="new-plans">
            {plans.map((plan, index) => {
              let variant = plan.user_pricing.filter(i => (!i['from'] || i['from'] <= this.state.users) && (!i['to'] || i['to'] >= this.state.users))[0]
              if (!variant) {
                variant = plan
              }

              let userPrice = Math.round(variant[`${this.state.currency.toLowerCase()}`] * 100) / 100

              if (this.state.period == 'yearly') {
                userPrice = Math.round(userPrice * 0.8)
              }

              let total = userPrice * this.state.users
              let limitUsers = variant['limits_users'] || plan.limits_users

              return (
                <div key={plan.id} className={classNames('plan', {
                    'blue': index == 0,
                    'red': index == 1,
                    'black': index == 2
                  })}>
                  <div className="head">
                    <div className="title">{plan[`name_${I18n.locale}`]}</div>
                    <div className="price"><strong>{total.toLocaleString('cs')}</strong> {symbol}/{I18n.t('month').toLowerCase()}</div>
                    <div className="price per-user">{userPrice.toLocaleString('cs')} {symbol}/{I18n.t('month').toLowerCase()}/{I18n.t('user-count', {count: 1}).toLowerCase()}</div>
                  </div>
                  <div className="wave">
                    <Wave />
                  </div>
                  <div className="inner">
                    <div className="features">
                      <div className="feature">
                        <div className="name">
                          {I18n.t('limits_objects')}
                        </div>
                        <div className="value">
                          <strong>
                            {variant['limits_objects'] || plan.limits_objects || Helper.capitalize(I18n.t('unlimited'))}
                          </strong>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('all-caflou-modules')}
                        </div>
                        <div className="value"></div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('repetition')}
                        </div>
                        <div className="value">
                          <strong>{variant['limits_repeatables'] || plan.limits_repeatables || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {I18n.t('pattern-count', {count: variant['limits_repeatables'] || plan.limits_repeatables || 99})}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('pairing')}
                        </div>
                        <div className="value">
                          <strong>{variant['limits_pair_models'] || plan.limits_pair_models || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {I18n.t('bank-count', {count: variant['limits_pair_models'] || plan.limits_pair_models || 99})}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('workflow-management')}
                        </div>
                        <div className="value">
                          <strong>{variant['limits_workflow_causes'] || plan.limits_workflow_causes || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {I18n.t('process-count', {count: variant['limits_workflow_causes'] || plan.limits_workflow_causes || 99})}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('payments')}
                        </div>
                        <div className="value">
                          <strong>{variant['limits_payment_rules'] || plan.limits_payment_rules || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {I18n.t('rules-count', {count: variant['limits_payment_rules'] || plan.limits_payment_rules || 99})}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('products-name')}
                        </div>
                        <div className="value">
                          <strong>{variant['limits_products'] || plan.limits_products || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {I18n.t('objects-count', {count: variant['limits_products'] || plan.limits_products || 99})}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">
                          {I18n.t('files')}
                        </div>
                        <div className="value">
                          {variant['limits_data'] || plan.limits_data ? (
                            <React.Fragment>
                              <strong>
                                {filesize((variant['limits_data'] || plan.limits_data) * 1048576, {output: "object"}).value}
                              </strong> <span className="unit">
                              {filesize((variant['limits_data'] || plan.limits_data) * 1048576, {output: "object"}).symbol}
                            </span>
                            </React.Fragment>
                          ) : (
                            <strong>{Helper.capitalize(I18n.t('unlimited'))}</strong>
                          )}
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">API</div>
                        <div className="value">
                          <strong>{variant['limits_api_calls'] || plan.limits_api_calls || Helper.capitalize(I18n.t('unlimited'))}</strong> <span className="unit">
                            {`${I18n.t('api-request-count', {count: variant['limits_api_calls'] || plan.limits_api_calls || 99})}/${I18n.t('month-count', {count: 1})}`}
                          </span>
                        </div>
                      </div>
                      <div className="feature">
                        <div className="name">{I18n.t('starting_consultation')}</div>
                        <div className="value"><strong>{plan.starting_consultation}</strong> <span className="unit">{I18n.t('minute-count', {count: 30})}</span></div>
                      </div>
                      {plan.id != 29 && (
                        <div className="feature">
                          <div className="name">
                            <strong>
                              {I18n.t('extra-features')}
                            </strong>
                          </div>
                          <div className="value">
                            <Tooltip content={`<span class='nowrap'>${I18n.t('extra-features-hint').join('<br>')}</span>`} placement='left'>
                              <i className="fal fa-question-circle"></i>
                            </Tooltip>
                          </div>
                        </div>
                      )}
                      {plan.private_cloud && (
                        <div className="feature">
                          <div className="name">
                            <strong>
                              {I18n.t('private-cloud')}
                            </strong>
                          </div>
                          <div className="value">
                            <Tooltip content={I18n.t('private-cloud-hint')} placement='left'>
                              <i className="fal fa-question-circle"></i>
                            </Tooltip>
                          </div>
                        </div>
                      )}
                    </div>
                    <a
                      data-turbolinks="false"
                      className={classNames('btn', {
                        'blue': index == 0,
                        'red': index == 1,
                        'black': index == 2
                      })}
                      href={plan.private_cloud ? `mailto:${supportEmail}?subject=${I18n.t('plan-interest', {name: plan[`name_${I18n.locale}`]})}` : this.props.start_settings_url}>

                      {plan.private_cloud ? (
                        <div className="center">
                          {I18n.t('i-am-interested')}
                        </div>
                      ) : (
                        <>
                          <div className="left">
                            {I18n.t('activate')}
                          </div>
                          <div className="right">
                            {total.toLocaleString('cs')} <em>{symbol}/{I18n.t('month').toLowerCase()}</em>
                          </div>
                        </>
                      )}
                    </a>
                  </div>
                </div>
              )
            })}
          </div>

          <div className={classNames('step', {'d-none': I18n.locale == 'cs'})}>
            <div className="selection alone">
              <div className="currency-switcher">
                <div className="currency euro">€</div>
                <div className="onoffswitch">
                  <input
                    type="checkbox"
                    name="dollars"
                    id="dollars"
                    className="onoffswitch-checkbox"
                    onChange={this.handleDollarChange.bind(this)} />
                  <label className="onoffswitch-label" htmlFor="dollars">&nbsp;</label>
                </div>
                <div className="currency dollar">$</div>
              </div>
            </div>
          </div>

          <div className="note">
            {I18n.t('pricing-without-vat')} <a href={pricingItemsHintLink} target="_blank">{I18n.t('pricing-items-hint')}</a>
          </div>

          {defaultPlan ? (
            <div className="step plan">
              <div className="title">
                <strong className="green">{defaultPlan[`name_${I18n.locale}`]}</strong>
                <p>
                  {I18n.t('number-of-users')} ({defaultPlan.limits_users})  •  {I18n.t('all-caflou-modules')} ({defaultPlan.limits_objects} {I18n.t('objects-count', {count: defaultPlan.limits_objects})})  •  API ({defaultPlan.limits_api_calls} {`${I18n.t('api-request-count', {count: defaultPlan.limits_api_calls})}/${I18n.t('month-count', {count: 1})}`})  •  {I18n.t('workflow-management')} ({defaultPlan.limits_workflow_causes} {I18n.t('process-count', {count: defaultPlan.limits_workflow_causes})})  •  {I18n.t('files')} ({filesize(defaultPlan.limits_data * 1048576, {output: "object"}).value} {filesize(defaultPlan.limits_data * 1048576, {output: "object"}).symbol})
                </p>
              </div>
              <div className="selection">
                <a href={this.props.start_url} className="btn btn-primary">{I18n.t('try-for-free')}</a>
              </div>
            </div>
          ) : null}

          {/*
          <div className="step plan">
            <div className="title">
              <strong className="black">Enterprise</strong>
              <p>
                Dedicated cloud resources  •  Priority support  •  Custom solutions
              </p>
            </div>
            <div className="selection">
              <a href={I18n.locale == 'cs' ? 'https://www.caflou.cz/kontakty-a-tym' : 'https://www.caflou.com/contact'} className="btn black">I18n.t('contact')</a>
            </div>
          </div>
          */}

        </div>
      </div>
    )
  }
}

export default Pricing
